
import React, { Fragment } from 'react';
import Button from '@cmsgov/design-system-core/dist/components/Button/Button';
import ReactHtmlParser from 'react-html-parser';
import { FormattedMessage, useIntl } from 'react-intl/dist';


const SaveResultModal = props => {
    
    const {
        actions: {
            hideModal
        },
        boundAnchor,
        modal: {
            modalData: {
                callback,
                saveResult: {
                    errorMessage = '',
                    success,
                    successMessage
                }
            }
        },
        secondaryTopAnchors: [
            anchor_2
        ],
    } = props;
    
    const handleClick = () => {
        hideModal();
        if (success) {
            callback();
        }
    };
    
    const intlApi = useIntl();

    const EMAIL_DUPLICATION_ERRORS = [ '101', '102' ];
    const EMAIL_DUPLICATION_FAILURE_ID = 'preferences_page.email_duplication_failure';
    
    return (
        <Fragment>
            <div className = 'gi-modal__body' >
                {
                    success
                        ? (
                            <FormattedMessage
                                id = { successMessage }
                                tagName = 'p'
                            />
                        )
                        : EMAIL_DUPLICATION_ERRORS.includes(errorMessage)
                            ? (
                                <FormattedMessage
                                    id = { EMAIL_DUPLICATION_FAILURE_ID }
                                    tagName = 'p'
                                />
                            )
                            : (
                                <p>
                                    { ReactHtmlParser(intlApi.formatMessage({ id: 'preferences_page.save_failed' }, { errorMessage })) }
                                </p>
                            )

                }
            </div>
            <div className = 'gi-modal__footer' >
                <div className = 'grid-row controls' >
                    <div className = 'grid-offset-6 txt-left' >
                        <Button
                            className = 'usa-button gi-button gi-button__primary'
                            onClick = { handleClick }
                            inputRef = { boundAnchor(anchor_2) }
                        >
                            <FormattedMessage id = 'button.ok' />
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default SaveResultModal;